<template>
	<div class="content">
		<div class="map-info">
			<span>地图名称：{{ $route.query.name || '-' }}</span>
			<span>设备总数：{{ uwbLists.length }}</span>
		</div>
		<div class="tool">
			<button @click="getUwbLists" hover-class="none" class="active">刷新位置</button>
			<button @click="toggleAutoRefresh" hover-class="active">
				{{ isAutoRefresh ? '停止自动刷新' : '开启自动刷新' }}
			</button>
			<button @click="allowLocation" hover-class="none" class="active">拾取坐标</button>
			<button @click="toggleTrackPlayer" hover-class="none" class="active">轨迹回放</button>
		</div>

		<!-- 轨迹回放控制栏（默认隐藏） -->
		<div class="track-control" v-if="isShowTrackControl">
			<!-- 进度条 -->
			<div class="track-slider">
				<input type="range" v-model="currentProgress" :min="trackTimeRange.min" :max="trackTimeRange.max"
					@input="handleProgressChange" class="slider-input">
				<span class="time-label">{{ formatTime(currentProgress) }}</span>
			</div>
			<!-- 控制按钮组 -->
			<div class="track-buttons">
				<button @click="handlePlayPause" class="track-btn">
					{{ isPlaying ? '暂停' : '播放' }}
				</button>
				<button @click="handleStop" class="track-btn">停止</button>
				<div class="speed-group">
					<span v-for="speed in speedOptions" :key="speed.value" @click="setPlaySpeed(speed.value)"
						:class="{'active': currentSpeed === speed.value}" class="speed-item">
						x{{ speed.label }}
					</span>
				</div>
			</div>
		</div>

		<div id="fengmap"></div>

		<div class="custom-dialog" v-if="isShowDialog">
			<div class="dialog-content">
				<h3 class="dialog-title">地图坐标</h3>
				<div class="dialog-message">
					<p>x: {{ x }}</p>
					<p>y: {{ y }}</p>
				</div>
				<button class="dialog-confirm" @click="isShowDialog = false">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
	import device from "../../model/device";
	import {
		FMMap,
		FMMarkerAnchor,
		FMTextAlign,
		FMType,
		FMLineType,
		FMImageMarker
	} from "../../plugins/fmap/fengmap.map.min";
	import {
		FMMarkerRenderMode,
		FMCompositeMarker
	} from "../../plugins/fmap/fengmap.plugin.markers.min";
	import {
		FMTracksPlayer
	} from "../../plugins/fmap/fengmap.plugin.location.min";

	// 常量定义
	const DEFAULT_LEVEL = 3;
	const BASE_PLAY_SPEED = 100;
	const AUTO_REFRESH_INTERVAL = 5000;
	//const DEFAULT_MARKER_ICON = '/user.png';
	export default {
		data() {
			return {
				uwbLists: [],
				isLocation: false,
				isShowDialog: false,
				x: '',
				y: '',

				// 实时位置自动刷新相关
				isAutoRefresh: false,
				autoRefreshTimer: null,

				// 轨迹回放相关状态
				isShowTrackControl: false,
				isPlaying: false,
				isPause: false,
				isComplete: false,
				currentProgress: 0,
				currentSpeed: 1,
				trackTimeRange: {
					min: 0,
					max: 0
				},
				speedOptions: [{
						label: 0.5,
						value: 0.5
					},
					{
						label: 1,
						value: 1
					},
					{
						label: 1.2,
						value: 1.2
					},
					{
						label: 1.5,
						value: 1.5
					},
					{
						label: 2,
						value: 2
					},
					{
						label: 3,
						value: 3
					}
				],

				// 完整轨迹数据
				trackData: [{
						level: 3,
						x: 11791427.270652,
						y: 3418810.7825,
						z: 0.1,
						time: '2025/10/1 11:30:56'
					},
					{
						level: 3,
						x: 11791430.240119,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:31:22'
					},
					{
						level: 3,
						x: 11791433.415125,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:31:48'
					},
					{
						level: 3,
						x: 11791435.79638,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:32:14'
					},
					{
						level: 3,
						x: 11791438.57451,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:32:40'
					},
					{
						level: 3,
						x: 11791440.823473,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:33:06'
					},
					{
						level: 3,
						x: 11791443.469312,
						y: 3418811.058754,
						z: 0.1,
						time: '2025/10/1 11:33:31'
					},
					{
						level: 3,
						x: 11791446.908902,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:33:57'
					},
					{
						level: 3,
						x: 11791449.951616,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:34:23'
					},
					{
						level: 3,
						x: 11791453.788082,
						y: 3418811.058754,
						z: 0.1,
						time: '2025/10/1 11:34:49'
					},
					{
						level: 3,
						x: 11791456.169337,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:35:15'
					},
					{
						level: 3,
						x: 11791459.212052,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:35:41'
					},
					{
						level: 3,
						x: 11791461.990182,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:36:07'
					},
					{
						level: 3,
						x: 11791465.032897,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:36:33'
					},
					{
						level: 3,
						x: 11791467.943319,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:36:59'
					},
					{
						level: 3,
						x: 11791470.72145,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:37:25'
					},
					{
						level: 3,
						x: 11791473.49958,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:37:51'
					},
					{
						level: 3,
						x: 11791476.806878,
						y: 3418810.926462,
						z: 0.1,
						time: '2025/10/1 11:38:17'
					},
					{
						level: 3,
						x: 11791479.981885,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:38:42'
					},
					{
						level: 3,
						x: 11791483.421475,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:39:08'
					},
					{
						level: 3,
						x: 11791486.464189,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:39:34'
					},
					{
						level: 3,
						x: 11791490.962115,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:40:00'
					},
					{
						level: 3,
						x: 11791493.607954,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:40:26'
					},
					{
						level: 3,
						x: 11791495.724625,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:40:52'
					},
					{
						level: 3,
						x: 11791498.767339,
						y: 3418811.058754,
						z: 0.1,
						time: '2025/10/1 11:41:18'
					},
					{
						level: 3,
						x: 11791502.206929,
						y: 3418811.455629,
						z: 0.1,
						time: '2025/10/1 11:41:44'
					},
					{
						level: 3,
						x: 11791505.381936,
						y: 3418812.513965,
						z: 0.1,
						time: '2025/10/1 11:42:10'
					},
					{
						level: 3,
						x: 11791506.969439,
						y: 3418813.5723,
						z: 0.1,
						time: '2025/10/1 11:42:36'
					},
					{
						level: 3,
						x: 11791508.42465,
						y: 3418815.027512,
						z: 0.1,
						time: '2025/10/1 11:43:02'
					},
					{
						level: 3,
						x: 11791510.276737,
						y: 3418816.350431,
						z: 0.1,
						time: '2025/10/1 11:43:28'
					},
					{
						level: 3,
						x: 11791512.657992,
						y: 3418817.144182,
						z: 0.1,
						time: '2025/10/1 11:43:54'
					},
					{
						level: 3,
						x: 11791515.96529,
						y: 3418817.67335,
						z: 0.1,
						time: '2025/10/1 11:44:19'
					},
					{
						level: 3,
						x: 11791518.478837,
						y: 3418817.144182,
						z: 0.1,
						time: '2025/10/1 11:44:45'
					},
					{
						level: 3,
						x: 11791520.7278,
						y: 3418816.482723,
						z: 0.1,
						time: '2025/10/1 11:45:11'
					},
					{
						level: 3,
						x: 11791523.241346,
						y: 3418816.085847,
						z: 0.1,
						time: '2025/10/1 11:45:37'
					},
					{
						level: 3,
						x: 11791526.284061,
						y: 3418815.027512,
						z: 0.1,
						time: '2025/10/1 11:46:03'
					},
					{
						level: 3,
						x: 11791528.797607,
						y: 3418814.23376,
						z: 0.1,
						time: '2025/10/1 11:46:29'
					},
					{
						level: 3,
						x: 11791530.649694,
						y: 3418813.836884,
						z: 0.1,
						time: '2025/10/1 11:46:55'
					},
					{
						level: 3,
						x: 11791532.501781,
						y: 3418812.513965,
						z: 0.1,
						time: '2025/10/1 11:47:21'
					},
					{
						level: 3,
						x: 11791534.221577,
						y: 3418811.323337,
						z: 0.1,
						time: '2025/10/1 11:47:47'
					},
					{
						level: 3,
						x: 11791536.205956,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:48:13'
					},
					{
						level: 3,
						x: 11791540.174713,
						y: 3418810.529586,
						z: 0.1,
						time: '2025/10/1 11:48:39'
					},
					{
						level: 3,
						x: 11791543.878888,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:49:05'
					},
					{
						level: 3,
						x: 11791548.905981,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:49:30'
					},
					{
						level: 3,
						x: 11791551.419528,
						y: 3418810.529586,
						z: 0.1,
						time: '2025/10/1 11:49:56'
					},
					{
						level: 3,
						x: 11791554.197658,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:50:22'
					},
					{
						level: 3,
						x: 11791556.446621,
						y: 3418810.79417,
						z: 0.1,
						time: '2025/10/1 11:50:48'
					},
					{
						level: 3,
						x: 11791559.489335,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:51:14'
					},
					{
						level: 3,
						x: 11791561.87059,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:51:40'
					},
					{
						level: 3,
						x: 11791565.574764,
						y: 3418810.661878,
						z: 0.1,
						time: '2025/10/1 11:52:06'
					},
					{
						level: 3,
						x: 11791568.220603,
						y: 3418810.397294,
						z: 0.1,
						time: '2025/10/1 11:52:32'
					},
					{
						level: 3,
						x: 11791570.204982,
						y: 3418809.868126,
						z: 0.1,
						time: '2025/10/1 11:52:58'
					},
					{
						level: 3,
						x: 11791570.73415,
						y: 3418808.412915,
						z: 0.1,
						time: '2025/10/1 11:53:24'
					},
					{
						level: 3,
						x: 11791571.395609,
						y: 3418806.296244,
						z: 0.1,
						time: '2025/10/1 11:53:50'
					},
					{
						level: 3,
						x: 11791571.792485,
						y: 3418804.179573,
						z: 0.1,
						time: '2025/10/1 11:54:16'
					},
					{
						level: 3,
						x: 11791572.189361,
						y: 3418802.062902,
						z: 0.1,
						time: '2025/10/1 11:54:42'
					},
					{
						level: 3,
						x: 11791573.115404,
						y: 3418800.475399,
						z: 0.1,
						time: '2025/10/1 11:55:07'
					},
					{
						level: 3,
						x: 11791575.099783,
						y: 3418799.946231,
						z: 0.1,
						time: '2025/10/1 11:55:33'
					},
					{
						level: 3,
						x: 11791577.216454,
						y: 3418799.681648,
						z: 0.1,
						time: '2025/10/1 11:55:59'
					},
					{
						level: 3,
						x: 11791579.333125,
						y: 3418799.946231,
						z: 0.1,
						time: '2025/10/1 11:56:25'
					},
					{
						level: 3,
						x: 11791582.111256,
						y: 3418799.946231,
						z: 0.1,
						time: '2025/10/1 11:56:51'
					},
					{
						level: 3,
						x: 11791584.49251,
						y: 3418799.813939,
						z: 0.1,
						time: '2025/10/1 11:57:17'
					},
					{
						level: 3,
						x: 11791587.138349,
						y: 3418799.813939,
						z: 0.1,
						time: '2025/10/1 11:57:43'
					},
					{
						level: 3,
						x: 11791590.048772,
						y: 3418799.681648,
						z: 0.1,
						time: '2025/10/1 11:58:09'
					},
					{
						level: 3,
						x: 11791592.562318,
						y: 3418799.813939,
						z: 0.1,
						time: '2025/10/1 11:58:35'
					},
					{
						level: 3,
						x: 11791595.075865,
						y: 3418800.078523,
						z: 0.1,
						time: '2025/10/1 11:59:01'
					},
					{
						level: 3,
						x: 11791598.383163,
						y: 3418799.946231,
						z: 0.1,
						time: '2025/10/1 11:59:27'
					},
					{
						level: 3,
						x: 11791601.425878,
						y: 3418799.946231,
						z: 0.1,
						time: '2025/10/1 11:59:53'
					},
					{
						level: 3,
						x: 11791604.468592,
						y: 3418799.681648,
						z: 0.1,
						time: '2025/10/1 12:00:18'
					},
					{
						level: 3,
						x: 11791607.246723,
						y: 3418799.681648,
						z: 0.1,
						time: '2025/10/1 12:00:44'
					},
					{
						level: 3,
						x: 11791610.818605,
						y: 3418799.417064,
						z: 0.1,
						time: '2025/10/1 12:01:10'
					},
					{
						level: 3,
						x: 11791613.729027,
						y: 3418799.549356,
						z: 0.1,
						time: '2025/10/1 12:01:36'
					},
					{
						level: 3,
						x: 11791616.110282,
						y: 3418799.417064,
						z: 0.1,
						time: '2025/10/1 12:02:02'
					},
					{
						level: 3,
						x: 11791617.433201,
						y: 3418797.961852,
						z: 0.1,
						time: '2025/10/1 12:02:28'
					},
					{
						level: 3,
						x: 11791617.697785,
						y: 3418795.448306,
						z: 0.1,
						time: '2025/10/1 12:02:54'
					},
					{
						level: 3,
						x: 11791617.433201,
						y: 3418793.199343,
						z: 0.1,
						time: '2025/10/1 12:03:20'
					},
					{
						level: 3,
						x: 11791617.433201,
						y: 3418790.818088,
						z: 0.1,
						time: '2025/10/1 12:03:46'
					},
					{
						level: 3,
						x: 11791617.565493,
						y: 3418788.966001,
						z: 0.1,
						time: '2025/10/1 12:04:12'
					},
					{
						level: 3,
						x: 11791617.697785,
						y: 3418786.84933,
						z: 0.1,
						time: '2025/10/1 12:04:38'
					},
					{
						level: 3,
						x: 11791617.962369,
						y: 3418784.732659,
						z: 0.1,
						time: '2025/10/1 12:05:04'
					},
					{
						level: 3,
						x: 11791618.226953,
						y: 3418783.012864,
						z: 0.1,
						time: '2025/10/1 12:05:30'
					},
					{
						level: 3,
						x: 11791619.285288,
						y: 3418781.425361,
						z: 0.1,
						time: '2025/10/1 12:05:55'
					},
					{
						level: 3,
						x: 11791619.713584,
						y: 3418780.309148,
						z: 0.1,
						time: '2025/10/1 12:06:21'
					},
					{
						level: 3,
						x: 11791619.792959,
						y: 3418779.078833,
						z: 0.1,
						time: '2025/10/1 12:06:47'
					},
					{
						level: 3,
						x: 11791618.284831,
						y: 3418778.761332,
						z: 0.1,
						time: '2025/10/1 12:07:13'
					}
				],

				// 复合标注基础配置
				baseMarkerConfig: {
					height: 1,
					depth: false,
					anchor: {
						baseon: 'image',
						anchor: 'CENTER'
					},
					collision: true,
					render: FMMarkerRenderMode.BILLBOARD,
					rectanglevalue: 'FMBound',
					zoomRange: [0, 30],
					opacity: 100,
					tilt: 90,
					heading: 0,
					layout: {
						style: 'ttext-bimage',
						align: 'center',
						spacings: 0
					},
					media: {
						size: [32, 32]
					},
					text: {
						padding: [0, 0, 0, 0],
						plateColor: '#54d521',
						plateStrokeColor: '#00CD00',
						plateStrokeWidth: 2,
						plateOpacity: 100,
						plateStrokeRadius: 0,
						content: {
							textAlign: 'Center',
							lineSpacing: 10,
							fontSize: 12,
							fontWeight: 200,
							fontFamily: 'Microsoft YaHei',
							fillColor: 'rgba(0, 0, 238)',
							strokeColor: 'rgba(255, 204, 255)',
							strokeWidth: 1
						}
					}
				}
			}
		},
		mounted() {
			// 非响应式属性（避免Vue代理）
			this._map = null;
			this._markerInstances = []; // 实时位置标注实例
			this._trackMarkerInstances = []; // 轨迹相关标注实例
			this._tracksPlayer = null; // 轨迹回放实例
			// 事件回调存储（用于解绑）
			this._mapClickHandler = (event) => this.showLocation(event);
			this._mapLoadHandler = () => this.handleMapLoad();
			this._trackPlayingHandler = (params) => this.handleTrackPlaying(params);
			this._trackCompleteHandler = () => this.handleTrackComplete();

			this.initMap();
			this.initTrackTimeRange();
			// 打开时自动触发一次实时位置查询
			this.getUwbLists();
		},
		beforeUnmount() {
			// 停止自动刷新
			this.stopAutoRefresh();
			// 清除所有标注
			this.clearAllMarkers();
			this.clearAllTrackMarkers();
			// 解绑事件监听
			if (this._map) {
				this._map.off('click', this._mapClickHandler);
				this._map.off('load', this._mapLoadHandler);
				this._map.off('error', this._mapErrorHandler);
				if (typeof this._map.destroy === 'function') {
					this._map.destroy();
				}
			}
		},
		methods: {
			// 初始化轨迹时间范围
			initTrackTimeRange() {
				if (this.trackData.length === 0) return;
				const startTime = new Date(this.trackData[0].time).getTime();
				const endTime = new Date(this.trackData[this.trackData.length - 1].time).getTime();
				this.trackTimeRange = {
					min: startTime,
					max: endTime
				};
				this.currentProgress = startTime;
			},

			// 获取接口数据（实时位置核心方法）
			async getUwbLists() {
				try {
					const ret = await device.uwbLists({
						map_id: this.$route.query.map_id || '',
						client_id: this.$route.query.client_id || ''
					});
					if (ret.code === 200) {
						this.uwbLists = ret.data;
						// 数据更新后自动渲染标注（若地图已加载完成）
						if (this._map) {
							this.renderAllUwbMarkers();
						}
					}
				} catch (error) {
					console.error('实时位置获取失败：', error);
				}
			},

			// 初始化地图
			initMap() {
				const options = {
					container: document.getElementById('fengmap'),
					appName: '蜂鸟研发SDK_2_0',
					key: '57c7f309aca507497d028a9c00207cf8',
					mapID: '1514920297309614082',
					themeID: '1580453922356207618',
					level: DEFAULT_LEVEL,
					mapZoom: 19,
					maxTiltAngle: 90,
					minTiltAngle: 0
				};
				this._map = new FMMap(options);

				// 绑定地图事件
				this._map.on('click', this._mapClickHandler);
				this._map.on('load', this._mapLoadHandler);
				this._mapErrorHandler = (err) => {
					console.error('地图初始化失败：', err);
					// 可添加用户提示
				};
				this._map.on('error', this._mapErrorHandler);
			},

			// 地图加载完成处理
			handleMapLoad() {
				console.log('地图加载完成');
				if (this.uwbLists.length > 0) {
					this.renderAllUwbMarkers();
				}
			},

			// 循环渲染所有UWB标注
			renderAllUwbMarkers() {
				// 先移除已有标注，避免重复
				this.clearAllMarkers();

				// 遍历接口数据，创建每个标注
				this.uwbLists.forEach(item => {
					// 跳过无坐标或无名称的条目
					if (!item.coords || !item.name) return;

					// 合并基础配置和当前条目数据
					const markerConfig = {
						...this.baseMarkerConfig,
						x: item.coords.x,
						y: item.coords.y,
						media: {
							...this.baseMarkerConfig.media,
							url: item.icon,
						},
						text: {
							...this.baseMarkerConfig.text,
							content: {
								...this.baseMarkerConfig.text.content,
								text: item.name
							}
						}
					};

					// 创建并添加标注
					this.createSingleMarker(markerConfig);
				});
			},

			// 创建单个复合标注
			createSingleMarker(config) {
				// 处理文本格式
				const textArray = this.formatText(config.text.content.text);

				// 创建复合标注实例
				const marker = new FMCompositeMarker({
					...config,
					opacity: config.opacity / 100,
					anchor: {
						...config.anchor,
						anchor: FMMarkerAnchor[config.anchor.anchor]
					},
					text: {
						...config.text,
						plateOpacity: config.text.plateOpacity / 100,
						content: {
							...config.text.content,
							textAlign: FMTextAlign[config.text.content.textAlign],
							text: textArray
						}
					}
				});

				// 添加到当前楼层
				const floor = this._map.getFloor(DEFAULT_LEVEL);
				if (floor) {
					marker.addTo(floor);
					// 存储标注实例，用于后续清理
					this._markerInstances.push(marker);
				} else {
					console.warn('未找到对应楼层，无法添加标注');
				}
			},

			// 清除所有实时位置标注
			clearAllMarkers() {
				this._markerInstances.forEach(marker => {
					marker.remove();
				});
				this._markerInstances = [];
			},

			// 清除所有轨迹相关标注（起终点、轨迹线）
			clearAllTrackMarkers() {
				// 清除起终点标注
				this._trackMarkerInstances.forEach(marker => {
					marker.remove();
				});
				this._trackMarkerInstances = [];

				// 清除轨迹线和移动标注
				if (this._tracksPlayer) {
					this._tracksPlayer.off('playing', this._trackPlayingHandler);
					this._tracksPlayer.off('complete', this._trackCompleteHandler);
					this._tracksPlayer.destroy();
					this._tracksPlayer = null;
				}
			},

			// 文本格式化工具
			formatText(text) {
				if (Array.isArray(text)) {
					return text.map(item => typeof item === 'string' ? {
						text: item
					} : item);
				}
				return [{
					text: text
				}];
			},

			// 坐标显示逻辑
			showLocation(event) {
				this.x = event.coords.x || '';
				this.y = event.coords.y || '';
				if (this.isLocation) {
					this.isLocation = false;
					this.isShowDialog = true;
				}
			},

			// 坐标获取开关
			allowLocation() {
				this.isLocation = !this.isLocation;
				if (this.isLocation) {
					this.isShowDialog = false;
				}
			},

			// 切换轨迹回放控制栏显示/隐藏
			toggleTrackPlayer() {
				this.isShowTrackControl = !this.isShowTrackControl;
				// 显示时初始化轨迹回放，隐藏时清除轨迹
				if (this.isShowTrackControl) {
					// 开启轨迹回放时，自动停止实时位置刷新并清除标注
					this.stopAutoRefresh();
					this.clearAllMarkers();
					this.initTrackPlayer();
				} else {
					this.stopTrackPlay();
					this.clearAllTrackMarkers();
				}
			},

			// 初始化轨迹回放
			initTrackPlayer() {
				// 先清除已有轨迹
				this.clearAllTrackMarkers();

				// 初始化轨迹播放插件
				this._tracksPlayer = new FMTracksPlayer(this._map);

				// 设置路径轨迹数据
				this._tracksPlayer.setTracks(this.trackData);

				// 设置线的样式（带箭头的动态轨迹线）
				this._tracksPlayer.setTrackStyle({
					width: 6,
					radius: 1,
					type: FMLineType.ARROW,
					animate: true,
					height: 0,
					color: '#1890ff'
				});

				// 设置移动标注样式（蓝色定位点）
				const locationMarker = {
					type: FMType.LOCATION_MARKER,
					options: {
						url: 'https://developer.fengmap.com/fmAPI/images/bluedot.png',
						height: 0.2,
						x: this.trackData[0].x,
						y: this.trackData[0].y,
						level: DEFAULT_LEVEL,
						size: 24,
					}
				};
				this._tracksPlayer.setMarkerStyle(locationMarker.type, locationMarker.options);

				// 添加起终点标注
				this.addStartEndMarker();

				// 将轨迹线和定位点渲染到地图上
				this._tracksPlayer.render();

				// 设置初始速度
				this._tracksPlayer.setSpeed(this.currentSpeed * BASE_PLAY_SPEED);

				// 绑定轨迹事件
				this._tracksPlayer.on('playing', this._trackPlayingHandler);
				this._tracksPlayer.on('complete', this._trackCompleteHandler);
			},

			// 轨迹播放中回调
			handleTrackPlaying(params) {
				this.currentProgress = params.progress;
			},

			// 轨迹播放完成回调
			handleTrackComplete() {
				this.isPlaying = false;
				this.isComplete = true;
				this.isPause = false;
			},

			// 添加起终点标注
			addStartEndMarker() {
				if (this.trackData.length === 0) return;

				const startPoint = this.trackData[0];
				const endPoint = this.trackData[this.trackData.length - 1];
				const floor = this._map.getFloor(DEFAULT_LEVEL);
				if (!floor) return;

				// 起点（绿色）
				const startMarker = new FMImageMarker({
					x: startPoint.x,
					y: startPoint.y,
					url: 'https://developer.fengmap.com/fmAPI/images/start.png',
					size: 32,
					height: 0.2,
					anchor: FMMarkerAnchor.BOTTOM,
					depth: false,
					collision: true
				});

				// 终点（红色）
				const endMarker = new FMImageMarker({
					x: endPoint.x,
					y: endPoint.y,
					url: 'https://developer.fengmap.com/fmAPI/images/end.png',
					size: 32,
					height: 0.2,
					anchor: FMMarkerAnchor.BOTTOM,
					depth: false,
					collision: true
				});

				startMarker.addTo(floor);
				endMarker.addTo(floor);
				this._trackMarkerInstances.push(startMarker, endMarker);
			},

			// 播放/暂停切换
			handlePlayPause() {
				if (!this._tracksPlayer) return;

				if (this.isPlaying) {
					// 暂停
					this._tracksPlayer.pause();
					this.isPlaying = false;
					this.isPause = true;
				} else {
					// 播放
					if (this.isComplete) {
						// 播放完成后重新开始
						this._tracksPlayer.start();
						this._tracksPlayer.play();
						this.isComplete = false;
					} else {
						this._tracksPlayer.play();
					}
					this.isPlaying = true;
					this.isPause = false;
				}
			},

			// 停止播放
			handleStop() {
				if (!this._tracksPlayer) return;
				this._tracksPlayer.stop();
				this.isPlaying = false;
				this.isPause = false;
				this.isComplete = false;
				// 进度条回到起点
				this.currentProgress = this.trackTimeRange.min;
			},

			// 停止轨迹播放（隐藏控制栏时调用）
			stopTrackPlay() {
				if (this._tracksPlayer) {
					this._tracksPlayer.stop();
					this.isPlaying = false;
					this.isPause = false;
					this.isComplete = false;
				}
			},

			// 设置播放倍速
			setPlaySpeed(speed) {
				this.currentSpeed = speed;
				if (this._tracksPlayer) {
					this._tracksPlayer.setSpeed(this.currentSpeed * BASE_PLAY_SPEED);
				}
			},

			// 进度条拖动改变播放进度
			handleProgressChange() {
				if (!this._tracksPlayer || this.isPlaying) return;
				this._tracksPlayer.setProgress(this.currentProgress);
			},

			// 时间格式化（时间戳转yyyy-MM-dd HH:mm:ss）
			formatTime(timestamp) {
				const date = new Date(timestamp);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hour = String(date.getHours()).padStart(2, '0');
				const minute = String(date.getMinutes()).padStart(2, '0');
				const second = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
			},

			// 切换自动刷新（开启/停止）
			toggleAutoRefresh() {
				if (this.isAutoRefresh) {
					this.stopAutoRefresh();
				} else {
					this.startAutoRefresh();
				}
			},

			// 开启自动刷新
			startAutoRefresh() {
				// 先停止已有定时器
				this.stopAutoRefresh();
				// 立即执行一次
				this.getUwbLists();
				// 创建定时器
				this.autoRefreshTimer = setInterval(() => {
					this.getUwbLists();
				}, AUTO_REFRESH_INTERVAL);
				this.isAutoRefresh = true;
				console.log('实时位置自动刷新已开启（每5秒）');
			},

			// 停止自动刷新
			stopAutoRefresh() {
				if (this.autoRefreshTimer) {
					clearInterval(this.autoRefreshTimer);
					this.autoRefreshTimer = null;
				}
				this.isAutoRefresh = false;
				console.log('实时位置自动刷新已停止');
			}
		}
	}
</script>

<style scoped>
	#fengmap {
		width: 100%;
		height: 500px;
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		overflow: hidden;
		position: relative;
	}

	.content {
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		padding-top: 10px;
	}

	.map-info {
		margin-left: 30px;
		margin-bottom: 12px;
		font-size: 15px;
		font-weight: 600;
		color: #303133;
		display: flex;
		gap: 30px;
	}

	.tool {
		margin-left: 30px;
		margin-bottom: 20px;
	}

	.tool button {
		margin-right: 10px;
		padding: 8px 16px;
		border: none;
		border-radius: 4px;
		background: #1989fa;
		color: #fff;
		cursor: pointer;
	}

	.tool button.active {
		background: #0e75d3;
	}

	/* 轨迹回放控制栏样式 */
	.track-control {
		margin-left: 30px;
		margin-bottom: 20px;
		padding: 15px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		width: calc(100% - 80px);
	}

	.track-slider {
		display: flex;
		align-items: center;
		gap: 15px;
		margin-bottom: 15px;
	}

	.slider-input {
		flex: 1;
		height: 6px;
		border-radius: 3px;
		background: #e5e6eb;
		outline: none;
		-webkit-appearance: none;
	}

	.slider-input::-webkit-slider-thumb {
		-webkit-appearance: none;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: #1989fa;
		cursor: pointer;
	}

	.time-label {
		font-size: 12px;
		color: #666;
		white-space: nowrap;
	}

	.track-buttons {
		display: flex;
		align-items: center;
		gap: 20px;
	}

	.track-btn {
		padding: 6px 12px;
		border: none;
		border-radius: 4px;
		background: #1989fa;
		color: #fff;
		cursor: pointer;
		font-size: 14px;
	}

	.track-btn:hover {
		background: #0e75d3;
	}

	.speed-group {
		display: flex;
		gap: 8px;
		margin-left: auto;
	}

	.speed-item {
		font-size: 12px;
		padding: 4px 8px;
		border-radius: 4px;
		cursor: pointer;
		color: #666;
		background: #f5f5f5;
	}

	.speed-item.active {
		background: #1989fa;
		color: #fff;
	}

	.custom-dialog {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	.dialog-content {
		width: 80%;
		max-width: 300px;
		background: #fff;
		border-radius: 12px;
		padding: 20px;
		box-sizing: border-box;
	}

	.dialog-title {
		font-size: 18px;
		font-weight: 600;
		margin: 0 0 15px 0;
		text-align: center;
	}

	.dialog-message {
		font-size: 16px;
		line-height: 1.8;
		margin: 0 0 20px 0;
		color: #333;
	}

	.dialog-confirm {
		width: 100%;
		height: 44px;
		background: #1989fa;
		color: #fff;
		border: none;
		border-radius: 8px;
		font-size: 16px;
		cursor: pointer;
	}

	.dialog-confirm:active {
		background: #0e75d3;
	}
</style>